module.exports = __webpack_public_path__ + "static/LamarLogoAgproz-dc7c4174519ebacf1a68679fd9d9ad64.png";